import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* istanbul ignore file */
import { fetchClient } from '@nike/fetch-client';
import { canUseDOM } from 'exenv';
import { useQuery } from '@tanstack/react-query';
import getWebShellClientLocale from "../../utils/get-webshellclient-locale";
import makeQueryKey from "../../utils/make-query-key";
export var parseFlagOverrides = function parseFlagOverrides(query) {
  var flagRegex = new RegExp('^flags..*');
  var overrides = {};
  query.forEach(function (value, key) {
    if (flagRegex.test(key)) {
      // Split query entry at '.' ex. flags.myFeature to get flag key
      var featureKey = key.split('.')[1];
      // Query value returns a string, need to make strict equality check and return associated boolean
      overrides[featureKey] = value === 'true' ? true : false;
    }
  });
  return overrides;
};
export var flagResolver = function flagResolver(country, config) {
  return Object.keys(config).reduce(function (flags, key) {
    var value = config[key];
    if (typeof value === 'boolean') {
      return _objectSpread(_objectSpread({}, flags), _defineProperty({}, key, value));
    }
    if (typeof value === 'string') {
      return _objectSpread(_objectSpread({}, flags), _defineProperty({}, key, country === value));
    }
    if (Array.isArray(value)) {
      return _objectSpread(_objectSpread({}, flags), _defineProperty({}, key, value.indexOf(country) > -1));
    }
    return _objectSpread(_objectSpread({}, flags), _defineProperty({}, key, false));
  }, {});
};
var getQueryParams = function getQueryParams() {
  return new URLSearchParams(window.location.search);
};
var FEATURE_FLAG_ASSET = "https://".concat(process.env.NEXT_PUBLIC_HOST_NAME, "/assets/experience/cart/static/feature-flags.json");
export var getOptions = function getOptions() {
  return {
    queryKey: makeQueryKey(['feature-flags']),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, _getWebShellClientLoc, country, featureFlagsByCountry, query, overrides, featureFlagsWithOverrides, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return fetchClient(FEATURE_FLAG_ASSET, {
                priority: 'high'
              });
            case 1:
              response = _context.sent;
              _getWebShellClientLoc = getWebShellClientLocale(), country = _getWebShellClientLoc.country;
              featureFlagsByCountry = flagResolver(country, response);
              query = getQueryParams(); // support overriding with query params
              overrides = parseFlagOverrides(query);
              featureFlagsWithOverrides = _objectSpread(_objectSpread({}, featureFlagsByCountry), overrides);
              return _context.abrupt("return", featureFlagsWithOverrides);
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.log("Error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message)); // eslint-disable-line no-console
              if (canUseDOM && window.newrelic && window.newrelic.addPageAction) {
                window.newrelic.addPageAction('feature-flag-fetch-error');
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }()
  };
};
var useFetchFeatureFlags = function useFetchFeatureFlags() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    select = _ref.select,
    placeholderData = _ref.placeholderData;
  return useQuery(_objectSpread(_objectSpread(_objectSpread({}, getOptions()), select && {
    select: select
  }), placeholderData && {
    placeholderData: placeholderData
  }));
};
export default useFetchFeatureFlags;